// Pentomino — i18n (ES default, EN secondary)
// Textos oficiales del Perfil Corporativo 2026 + borrador cliente (Sitio_Web_v1).

export const translations = {
    es: {
        nav: {
            home: "Inicio",
            services: "Servicios",
            commerce: "Comercios",
            banks: "Bancos",
            people: "Personas",
            about: "Nosotros",
            contact: "Contacto",
            cta: "Agenda una sesión",
            menu: "Menú",
            skip: "Saltar al contenido",
        },
        common: {
            ctaWhatsapp: "Habla por WhatsApp",
            ctaContact: "Agenda una sesión",
            ctaBack: "Volver a Inicio",
        },
        hero: {
            eyebrow: "Trust. Delivered.",
            titleA: "Reciclamos el efectivo",
            titleB: "donde se recibe.",
            lead: "Pentomino instala y opera cajeros recicladores dentro de comercios. El efectivo de las ventas se entrega en retiros en el mismo punto y solo el excedente viaja con la transportadora.",
            ctaMain: "Habla por WhatsApp",
            ctaAlt: "Cómo funciona el modelo",
            scrollHint: "Desliza para ver cómo",
        },
        kpis: {
            title: "La operación habla por sí sola.",
            lead: "Cifras verificables del modelo Pentomino: menos costo, menos riesgo, más liquidez en el punto de venta.",
            items: [
                { value: 90, suffix: "%", label: "menos costo de manejo de efectivo", detail: "comparado con el esquema tradicional de traslado de valores." },
                { value: 70, suffix: "%", label: "menos pago a transportadoras", detail: "solo viaja el excedente que no se recicló en el punto." },
                { value: 1.95, prefix: "$", suffix: " M", decimals: 2, label: "de ahorro anual documentado", detail: "caso real de un comercio ancla de la red Pentomino." },
                { value: 2, prefix: "T+1 · T+", label: "acreditación de depósitos", detail: "el comercio recibe su reintegro al siguiente día hábil.", customDisplay: "T+1 · T+2" },
            ],
            footnote: "Fuente: Perfil Corporativo Pentomino 2026 · Reporte de operación de la red, junio 2025.",
        },
        how: {
            eyebrow: "El modelo de reciclaje",
            title: "Tres movimientos. Un solo circuito.",
            lead: "El efectivo del comercio alimenta el cajero. Los retiros se liquidan vía PROSA. Solo lo que sobra viaja.",
            steps: [
                { n: "01", title: "El comercio deposita", body: "Cada corte entra directo al cajero reciclador. Equipo, fecha, hora y monto quedan registrados." },
                { n: "02", title: "Los clientes retiran", body: "Cualquier tarjetahabiente retira ese mismo efectivo. PROSA liquida entre bancos." },
                { n: "03", title: "Solo el excedente viaja", body: "Al llegar a ~80% de capacidad, la transportadora recoge solo el sobrante. Menos visitas, menos riesgo." },
            ],
        },
        services: {
            eyebrow: "Cinco líneas de servicio",
            title: "Una plataforma completa de efectivo e infraestructura.",
            lead: "Pentomino integra equipo físico, conectividad bancaria, operación 24/7 y modelo comercial sponsor.",
            items: [
                { tag: "CASH", title: "Pentomino CASH", body: "Reciclaje y administración de efectivo en el punto de venta. Depósitos del comercio y retiros desde el mismo cajero." },
                { tag: "NETWORK", title: "Pentomino NETWORK", body: "Red multibanco con conectividad PROSA y E-Global. Switching, ruteo y conciliación de operaciones." },
                { tag: "TECH", title: "Pentomino TECH", body: "Monitoreo 24/7 multivendor, alertas en tiempo real, mesa de ayuda y conciliación diaria." },
                { tag: "PAYMENTS", title: "Pentomino PAYMENTS", body: "Pago de servicios, recargas, transferencias y cobro de remesas en el mismo cajero del comercio." },
                { tag: "PARTNERS", title: "Pentomino PARTNERS", body: "Modelo sponsor con bancos e instituciones. Comercios ancla con ingresos compartidos por operación." },
            ],
        },
        audiences: {
            eyebrow: "Para quién es",
            title: "Tres públicos. Una misma pieza.",
            lead: "Cada actor del circuito tiene una pieza clara dentro del símbolo Pentomino.",
            items: [
                { piece: "1", tag: "Pieza 1 · la entrada", title: "Comercios", bullets: ["Menos recolecciones y menos manejo manual", "Participación por cada retiro realizado", "Más visitas con pagos y servicios en tu tienda"], cta: "Ver propuesta para comercios" },
                { piece: "4", tag: "Pieza 4 · la liquidación", title: "Bancos sponsor", bullets: ["Expansión de red sin CAPEX ni OPEX", "Adquisición de bajo costo, presencia de marca", "Fondeo del excedente por el canal habitual"], cta: "Ver propuesta para bancos" },
                { piece: "3", tag: "Pieza 3 · el usuario", title: "Personas", bullets: ["Servicios financieros en tu punto de compra", "Cero comisión para tarjetahabientes del sponsor", "Pagos, recargas y remesas en un mismo lugar"], cta: "Ver qué ofrecemos a personas" },
            ],
        },
        operation: {
            eyebrow: "Operación real",
            title: "No es una presentación. Es una red operando hoy.",
            lead: "En junio de 2025, por cada peso entregado en retiros entraron 1.95 pesos de los comercios. El efectivo se quedó trabajando en el punto de venta en lugar de viajar.",
            receipt: {
                title: "Corte de red · junio 2025",
                rows: [
                    ["Cajeros activos", "22"],
                    ["Depósitos de comercios", "$66.7 M"],
                    ["Entregado en retiros", "$34.2 M"],
                    ["Retiros realizados", "15,987"],
                    ["Consultas de saldo", "1,503"],
                    ["Entró por cada peso entregado", "1.95×"],
                ],
                source: "Fuente: reporte de operación de la red Pentomino, junio 2025.",
            },
        },
        closing: {
            eyebrow: "Hablemos",
            title: "Empecemos por una ubicación.",
            lead: "Elegimos juntos la sucursal con más venta en efectivo, dimensionamos el ahorro con tus datos y activamos un piloto medible.",
            ctaMain: "Habla por WhatsApp",
            ctaAlt: "Escríbenos un correo",
        },
        footer: {
            tag: "Cajeros recicladores de efectivo en comercios de México.",
            slogan: "Trust. Delivered.",
            product: "Producto",
            productLinks: [["Servicios", "/servicios"], ["Comercios", "/comercios"], ["Bancos", "/bancos"], ["Personas", "/personas"]],
            company: "Empresa",
            companyLinks: [["Nosotros", "/nosotros"], ["Contacto", "/contacto"]],
            contact: "Contacto",
            legal: "© 2026 Pentomino Cash Cajeros Automáticos, S.A.P.I. de C.V.",
            privacy: "Aviso de privacidad",
            addressLine1: "Av. Coyoacán 1622 P.B., Col. Del Valle Sur",
            addressLine2: "C.P. 03104, Benito Juárez, CDMX",
        },
        wa: {
            label: "Chat por WhatsApp",
            message: "Hola, me interesa conocer más sobre Pentomino",
        },
        pentomino: {
            marks: {
                "1": "Comercio",
                "2": "Cajero",
                "3": "Usuario",
                "4": "PROSA",
                "5": "ETV",
            },
        },
        chat: {
            openLabel: "Pregunta a Pentomino",
            fabTitle: "Asistente",
            fabSub: "Respuestas con IA",
            title: "Asistente Pentomino",
            subtitle: "Respuestas con IA · Claude",
            closeLabel: "Cerrar asistente",
            placeholder: "Escribe tu pregunta…",
            send: "Enviar",
            sending: "Pensando…",
            intro: "Hola. Puedo explicarte cómo funciona el reciclaje de efectivo, qué gana un comercio o un banco, y cómo se maneja el cumplimiento. ¿Qué te interesa?",
            suggestions: [
                "¿Cómo funciona el reciclaje de efectivo?",
                "¿Cuánto podría ahorrar mi comercio?",
                "¿Qué gana un banco como sponsor?",
                "¿En cuánto tiempo se acredita mi depósito?",
            ],
            typing: "Escribiendo",
            errorGeneric: "No pude conectar con el asistente.",
            errorFallbackCta: "Escríbenos por WhatsApp y te respondemos.",
            disclaimer: "El asistente puede equivocarse. Para cifras de tu caso, usa la calculadora o habla con nuestro equipo. No compartas datos bancarios ni personales.",
            waBtn: "WhatsApp",
            clear: "Nueva conversación",
            cleared: "Conversación reiniciada.",
        },
        // ===================== SERVICIOS =====================
        servicesPage: {
            eyebrow: "Qué hacemos",
            title: "Cinco líneas, una sola plataforma.",
            lead: "Pentomino integra equipo físico, conectividad bancaria, monitoreo 24/7 y un modelo comercial de patrocinio. Diseñado para que el efectivo trabaje donde se recibe.",
            sections: [
                {
                    tag: "CASH",
                    title: "Reciclaje y administración de efectivo",
                    body: "El cajero reciclador autentica, cuenta y resguarda los billetes del comercio. Cuando un cliente retira, usa ese mismo efectivo. Acreditación del excedente en T+1 a T+2.",
                    bullets: [
                        "Depósito del comercio con registro de equipo, fecha, hora y monto",
                        "Autenticación y resguardo seguro de billetes",
                        "Reintegro al comercio al siguiente día hábil (T+1 a T+2)",
                        "Capacidad y recolección programada al 80% del equipo",
                    ],
                },
                {
                    tag: "NETWORK",
                    title: "Red multibanco y conectividad",
                    body: "Conexión directa a PROSA y E-Global. Switching, ruteo y conciliación de cada operación entre bancos emisores y el banco patrocinador.",
                    bullets: [
                        "Conectividad PROSA y E-Global",
                        "Switching y ruteo transaccional",
                        "Conciliación diaria con cada contraparte",
                        "Operación interoperable con cualquier tarjetahabiente",
                    ],
                },
                {
                    tag: "TECH",
                    title: "Monitoreo 24/7 e infraestructura",
                    body: "Plataforma multivendor que vigila cada cajero en tiempo real: estado, nivel, incidencias y auditoría de operaciones. Mesa de ayuda y mantenimiento operativo.",
                    bullets: [
                        "Monitoreo 24/7 multivendor en tiempo real",
                        "Alertas por capacidad, falla, intento o excepción",
                        "Mesa de ayuda y despacho de mantenimiento",
                        "Conciliación diaria y bitácora de auditoría",
                    ],
                },
                {
                    tag: "PAYMENTS",
                    title: "Servicios transaccionales",
                    body: "Más que un cajero: servicios cotidianos que dan razones para entrar a la tienda y mantienen al cliente dentro del comercio.",
                    bullets: [
                        "Pago de servicios (luz, agua, teléfono, gas) e impuestos",
                        "Recarga de tiempo aire y recarga de TAG",
                        "Transferencias interbancarias",
                        "Pago de tarjetas y cobro de remesas",
                    ],
                },
                {
                    tag: "PARTNERS",
                    title: "Modelo sponsor y alianzas",
                    body: "El banco patrocinador pone la licencia y la liquidación; Pentomino pone equipo, operación y comercios. Ingresos compartidos por operación con los comercios ancla.",
                    bullets: [
                        "Patrocinio bancario: expansión sin CAPEX para el banco",
                        "Comercios ancla con participación por retiro y consulta",
                        "Integradores y partners regionales",
                        "Gobierno comercial con niveles de servicio acordados",
                    ],
                },
            ],
        },
        // ===================== COMERCIOS =====================
        commercePage: {
            audienceTag: "Comercios · pieza 1, la entrada del efectivo",
            eyebrow: "Para comercios",
            title: "Menos traslados. Más razones para entrar a tu tienda.",
            lead: "Tu efectivo se queda en el punto de venta y se entrega en retiros a tus clientes. Pagas menos recolecciones, tu equipo deja de embolsar y contar, y recibes una participación por cada retiro.",
            benefits: [
                { title: "Ahorro operativo", body: "Solo viaja el excedente. Menos visitas, menos cuota de riesgo y menos proceso por millar." },
                { title: "Ingreso por retiro", body: "Participas de las comisiones de cada retiro y consulta que se hace en tu cajero." },
                { title: "Una pantalla propia", body: "Promociones, lealtad y venta cruzada en el momento de mayor atención del cliente." },
                { title: "Más visitas", body: "Pagos, recargas y retiros: servicios cotidianos que traen gente a tu tienda." },
            ],
            timeTable: {
                title: "Hasta 72% menos tiempo de manejo de efectivo",
                lead: "Estimación para una tienda con 28 cortes al mes. Las tareas de embolsar, registrar, llenar papeletas y entregar a la transportadora desaparecen: el cajero cuenta y registra.",
                header: ["Actividad, 28 cortes", "Hoy", "Con reciclador"],
                rows: [
                    ["Juntar efectivo de cajas", "336 min", "168 min"],
                    ["Firma del ticket", "28 min", "28 min"],
                    ["Embolsado de efectivo", "140 min", "—"],
                    ["Registro en sistema de control", "140 min", "—"],
                    ["Llenado de papeletas", "140 min", "—"],
                    ["Depósito", "42 min", "42 min"],
                    ["Firma y entrega a la transportadora", "25 min", "—"],
                    ["Total", "851 min · 14.2 h", "238 min · 4 h"],
                ],
                footnote: "Tiempos estimados; se validan en el piloto.",
            },
            setup: {
                title: "Sin inversión en equipo",
                left: { h: "Pentomino pone", p: "El cajero reciclador, la instalación, la tecnología, el monitoreo 24/7, la mesa de ayuda y el mantenimiento." },
                right: { h: "Tu tienda pone", p: "El espacio, la energía y la conectividad, y el efectivo de las ventas que alimenta al cajero." },
            },
            steps: {
                title: "Cómo empezamos",
                lead: "Un piloto en una ubicación, con medición compartida desde el primer día.",
                items: [
                    { n: "01", h: "Seleccionar", p: "Las sucursales con mayor venta en efectivo y afluencia." },
                    { n: "02", h: "Dimensionar", p: "Costos actuales, frecuencia de traslado y oportunidad transaccional, con tus datos." },
                    { n: "03", h: "Activar", p: "Cajero, servicios, campaña inicial y medición compartida." },
                ],
            },
        },
        // ===================== BANCOS =====================
        banksPage: {
            audienceTag: "Bancos e instituciones · pieza 4, la liquidación",
            eyebrow: "Para bancos sponsor",
            title: "Más red transaccional, sin desplegar una red propia.",
            lead: "Pentomino pone los cajeros, las ubicaciones y la operación. Tu institución aporta la conexión al sistema de pagos y monetiza cada operación.",
            benefits: [
                { title: "Ingresos recurrentes", body: "Una comisión por cada retiro y consulta en la red, más los servicios que se acuerden." },
                { title: "Fondeo de bajo costo", body: "El excedente de los comercios llega a tus cuentas por el canal habitual de la transportadora." },
                { title: "Expansión sin CAPEX", body: "Equipo, ubicación, tecnología y operación diaria corren por cuenta de Pentomino." },
                { title: "Presencia y marca", body: "Servicios bancarios en puntos comerciales donde una sucursal no sería viable." },
            ],
            compliance: {
                title: "Más trazabilidad, no una nueva ruta para el efectivo",
                lead: "Los mismos canales, contrapartes y disparadores de reporte siguen activos. Pentomino añade evidencia electrónica al ciclo.",
                items: [
                    { h: "Sin contacto directo con el efectivo", p: "El banco recibe liquidaciones vía PROSA o depósitos de la transportadora. Nunca efectivo directo del comercio." },
                    { h: "La transportadora sigue siendo sujeto obligado", p: "Conserva sus avisos y controles conforme a su marco vigente." },
                    { h: "Cada depósito queda registrado", p: "Comercio identificado, equipo, fecha, hora y monto, con conciliación diaria." },
                    { h: "Límites y alertas a la medida", p: "Perfiles de comercio, límites por equipo, reglas de alerta y bitácora de eventos, definidos con tu área de Cumplimiento." },
                ],
            },
            roadmap: {
                title: "De la validación a un piloto controlado",
                lead: "Una secuencia con puertas de decisión y responsables claros.",
                items: [
                    { n: "01", h: "Mesa ejecutiva", p: "Alcance, responsables y criterios de éxito." },
                    { n: "02", h: "Due diligence", p: "Datos, controles, arquitectura y contrapartes." },
                    { n: "03", h: "Term sheet", p: "Comisiones, límites, garantías, niveles de servicio y gobierno." },
                    { n: "04", h: "Piloto", p: "Certificar, lanzar y medir un grupo acotado de equipos." },
                ],
            },
        },
        // ===================== PERSONAS =====================
        peoplePage: {
            audienceTag: "Personas · pieza 3, el usuario",
            eyebrow: "Para personas",
            title: "Servicios financieros donde ya haces compras.",
            lead: "Encuentra un cajero Pentomino en el comercio al que ya vas: retira efectivo, paga servicios, recarga tiempo aire o manda remesas sin salir de la tienda.",
            services: {
                title: "Qué puedes hacer en un cajero Pentomino",
                items: [
                    { h: "Retiro de efectivo", p: "Con cualquier tarjeta de débito o crédito aceptada en la red." },
                    { h: "Consulta de saldo", p: "Rápida y segura, en el mismo cajero donde haces tu compra." },
                    { h: "Pago de servicios", p: "Luz, agua, teléfono, gas e impuestos locales." },
                    { h: "Recarga de tiempo aire", p: "Todas las compañías principales y recarga de TAG." },
                    { h: "Transferencias y pago de tarjetas", p: "Entre bancos participantes, con confirmación inmediata." },
                    { h: "Cobro de remesas", p: "Recibe envíos del extranjero en pesos, sin complicaciones." },
                ],
            },
            perks: {
                title: "Pensado para ti",
                items: [
                    { h: "Cero comisión", p: "Si eres tarjetahabiente del banco patrocinador, no pagas comisión por retiro." },
                    { h: "En tu punto de compra", p: "Ahorra viajes al banco: los cajeros están donde ya haces tus compras del día." },
                    { h: "Horario del comercio", p: "Disponibles mientras la tienda esté abierta, sin filas en sucursales bancarias." },
                    { h: "Seguridad del comercio", p: "Vigilancia, cámaras y personal del propio comercio al momento de operar." },
                ],
            },
        },
        // ===================== NOSOTROS =====================
        aboutPage: {
            eyebrow: "Quiénes somos",
            title: "Convertimos efectivo disperso en infraestructura financiera.",
            lead: "Pentomino Cash es una empresa mexicana que conecta comercios, tecnología y sistema de pagos. Operamos una red de cajeros con reciclaje de efectivo en comercios de alta afluencia.",
            mission: {
                title: "No solo operamos cajeros",
                items: [
                    { h: "Red física", p: "Equipos, ubicaciones y operación en campo." },
                    { h: "Plataforma", p: "Monitoreo multivendor y gestión remota de cada equipo." },
                    { h: "Infraestructura", p: "Switching, ruteo y conciliación de operaciones." },
                    { h: "Modelo sponsor", p: "Escalamos transacciones a través de una institución patrocinadora, sin desplegar red bancaria propia." },
                ],
            },
            values: {
                title: "Trust. Delivered.",
                lead: "La confianza en el manejo de efectivo no se promete: se demuestra operando. Por eso trabajamos con tres reglas.",
                items: [
                    { n: "01", h: "Cifras con fecha y fuente", p: "Publicamos datos de operación real y decimos de cuándo son." },
                    { n: "02", h: "Cada tramo con su responsable", p: "Integramos actores regulados sin sustituir sus obligaciones." },
                    { n: "03", h: "Todo se mide", p: "Cada piloto arranca con criterios de éxito acordados y medición compartida." },
                ],
            },
            team: {
                title: "Equipo",
                lead: "Un equipo multidisciplinario con experiencia en operación financiera, tecnología y relaciones institucionales.",
                people: [
                    { name: "Lumen Yvonne Espinosa Félix", role: "Dirección General" },
                ],
                footnote: "El equipo completo se publica junto con los casos de éxito del primer piloto.",
            },
            legal: {
                title: "Datos legales",
                items: [
                    ["Razón social", "Pentomino Cash Cajeros Automáticos, S.A.P.I. de C.V."],
                    ["Domicilio fiscal", "Av. Coyoacán 1622 P.B., Col. Del Valle Sur, C.P. 03104, Benito Juárez, CDMX"],
                    ["Teléfono", "55 8580 2818"],
                    ["Correo", "lumen@pentocash.mx"],
                ],
            },
        },
        // ===================== CALCULADORAS =====================
        calc: {
            inputs: { title: "Captura tus datos" },
            tags: { porConfirmar: "Por confirmar", supuesto: "Supuesto" },
            groups: {
                tarifasETV: "Tarifas de tu transportadora",
                costosInternos: "Tus costos internos",
                operacionYComisiones: "Operación y comisiones",
                fondeo: "Fondeo del excedente",
            },
            labels: {
                sucursales: "Sucursales o puntos de venta",
                efectivoMensualPorSucursal: "Efectivo que recibe cada sucursal al mes",
                recoleccionesSemana: "Recolecciones por semana, por sucursal",
                retirosPorCajero: "Retiros esperados por cajero al mes",
                tarifaServicio: "Tarifa por servicio",
                cuotaRiesgoMillar: "Cuota de riesgo por millar",
                procesoMillar: "Proceso por millar",
                minutosExcedentes: "Minutos excedentes por servicio",
                horasPorServicio: "Horas de personal por recolección",
                costoHora: "Costo por hora del personal",
                diasTransito: "Días hasta que el depósito se acredita",
                tasaOportunidad: "Costo de oportunidad anual (%)",
                cajeros: "Cajeros Pentomino en tu red",
                efectivoDepositadoPorCajero: "Efectivo depositado por cajero al mes",
                comisionSponsorRetiro: "Comisión sponsor por retiro (sin IVA)",
                comisionSponsorConsulta: "Comisión sponsor por consulta (sin IVA)",
                pctConsultas: "Consultas por cada 100 retiros (%)",
                retiroPromedio: "Retiro promedio",
                diasPermanenciaFondeo: "Días de permanencia del fondeo",
                margenFondeoAnual: "Margen financiero anual (%)",
            },
            helps: {
                recoleccionesSemanaHelp: "Cuántas veces pasa hoy la transportadora.",
                retirosPorCajeroHelp: "La red Pentomino promedió 727 por cajero en junio de 2025. Tiendas con mucha afluencia superan 2,000.",
            },
            commerce: {
                hero: {
                    eyebrow: "Calculadora de ahorro",
                    title: "¿Cuánto ahorrarías con Pentomino?",
                    lead: "Captura tu operación real: sucursales, efectivo mensual y frecuencia actual de la transportadora. Compara en tiempo real tu costo de hoy contra un cajero reciclador.",
                },
                savingLabel: "Ahorro mensual estimado",
                extraCost: "Costo adicional mensual",
                perYear: "al año",
                ofCurrent: "de tu costo actual",
                perMonth: "Al mes",
                today: "Hoy",
                withPentomino: "Con Pentomino",
                pickups: "Recolecciones",
                cashShipped: "Efectivo trasladado",
                carrierPay: "Pago a la transportadora",
                internalCosts: "Costos internos",
                pentoFee: "Cuota de servicio Pentomino",
                yourShare: "Tu participación por retiros",
                netService: "Servicio Pentomino, neto de participación",
                totalCost: "Costo total",
                recycled: "del efectivo se entrega en retiros y ya no viaja",
                hoursFreed: "de personal liberadas al mes",
                warn: "Con estos datos el traslado tradicional sale más barato por {amount} al mes. Suele pasar cuando hay pocos retiros en el cajero: prueba con más retiros o con menos recolecciones actuales.",
                legend: { carrier: "Transportadora", internal: "Costos internos", netService: "Servicio Pentomino" },
                footnote: "Estimación con tarifas de referencia 2026 y operación real de la red. El caso definitivo se arma con tus datos y tu contrato de traslado. Cifras sin IVA.",
                ctaWithResult: "Mandar mi resultado de {amount} por WhatsApp",
            },
            sponsor: {
                hero: {
                    eyebrow: "Calculadora para sponsor",
                    title: "¿Cuánto genera para tu banco una red Pentomino?",
                    lead: "Ajusta el tamaño de la red, la comisión por operación y el margen de fondeo. Estima ingresos mensuales con los costos transaccionales vigentes.",
                },
                incomeLabel: "Ingreso mensual estimado",
                perYear: "al año",
                perAtmPerMonth: "por cajero al mes",
                feeWithdrawals: "Comisión por retiros",
                feeInquiries: "Comisión por consultas",
                participation: "Participación en la utilidad",
                fundingMargin: "Margen sobre el fondeo del excedente",
                totalMonthly: "Total mensual",
                composition: "Composición del ingreso",
                legend: { fees: "Comisiones", share: "Participación", funding: "Fondeo" },
                monthlyOps: "operaciones al mes",
                surplusDeposit: "de excedente depositado",
                prosaCleared: "liquidados vía PROSA",
                zeroInvestment: "de inversión en equipo para el sponsor",
                footnote: "Estimación. Las comisiones por operación provienen del costo transaccional vigente de la red; el margen sobre fondeo es un supuesto editable. Los términos finales se acuerdan en la mesa de trabajo.",
                ctaWithResult: "Mandar mi resultado de {amount} por WhatsApp",
            },
        },
        // ===================== CONTACTO =====================
        contact: {
            eyebrow: "Agenda una sesión",
            title: "Cuéntanos de tu operación.",
            lead: "Comercio, banco o socio: déjanos tus datos y uno de nuestros ejecutivos te contactará en menos de 24 horas hábiles. También puedes escribirnos por WhatsApp para una respuesta inmediata.",
            waBanner: {
                title: "WhatsApp — canal principal",
                sub: "Respuesta inmediata en horario de oficina",
                cta: "Abrir WhatsApp",
            },
            info: {
                title: "Datos de contacto",
                phoneLabel: "Teléfono",
                emailLabel: "Correo",
                addressLabel: "Oficinas",
                hoursLabel: "Horario",
                hours: "Lunes a viernes · 9:00 – 18:00 h (CDMX)",
            },
            map: {
                title: "Cómo llegar",
                lead: "Av. Coyoacán 1622 P.B., Col. Del Valle Sur, CDMX.",
            },
            form: {
                title: "Formulario de contacto",
                lead: "Déjanos tus datos y te contactamos.",
                name: "Nombre completo",
                email: "Correo electrónico",
                phone: "Teléfono",
                company: "Empresa o institución",
                type: "¿Eres?",
                typeOptions: [["comercio", "Comercio"], ["banco", "Banco o institución"], ["persona", "Persona interesada"], ["socio", "Socio comercial"]],
                message: "Mensaje",
                messagePlaceholder: "Cuéntanos brevemente qué buscas…",
                submit: "Enviar mensaje",
                submitting: "Enviando…",
                ok: "¡Gracias! Recibimos tu mensaje. Te contactamos en menos de 24 horas hábiles.",
                err: "No pudimos enviar tu mensaje. Intenta de nuevo o escríbenos por WhatsApp.",
            },
        },
    },
    en: {
        nav: {
            home: "Home",
            services: "Services",
            commerce: "Merchants",
            banks: "Banks",
            people: "People",
            about: "About",
            contact: "Contact",
            cta: "Book a session",
            menu: "Menu",
            skip: "Skip to content",
        },
        common: {
            ctaWhatsapp: "Chat on WhatsApp",
            ctaContact: "Book a session",
            ctaBack: "Back to Home",
        },
        hero: {
            eyebrow: "Trust. Delivered.",
            titleA: "We recycle cash",
            titleB: "where it comes in.",
            lead: "Pentomino installs and operates recycling ATMs inside merchants in Mexico. Sales cash is dispensed at the same point of sale and only the surplus is picked up.",
            ctaMain: "Chat on WhatsApp",
            ctaAlt: "How the model works",
            scrollHint: "Scroll to see how",
        },
        kpis: {
            title: "The operation speaks for itself.",
            lead: "Verifiable numbers from the Pentomino model: less cost, less risk, more liquidity at the point of sale.",
            items: [
                { value: 90, suffix: "%", label: "lower cash handling cost", detail: "versus the traditional cash-in-transit scheme." },
                { value: 70, suffix: "%", label: "less paid to CIT carriers", detail: "only the un-recycled surplus is picked up." },
                { value: 1.95, prefix: "$", suffix: " M MXN", decimals: 2, label: "documented annual savings", detail: "real case from an anchor merchant in the Pentomino network." },
                { value: 2, prefix: "T+1 · T+", label: "deposit credit timing", detail: "merchants get their reimbursement the next business day.", customDisplay: "T+1 · T+2" },
            ],
            footnote: "Source: Pentomino 2026 Corporate Profile · Network operations report, June 2025.",
        },
        how: {
            eyebrow: "The recycling model",
            title: "Three moves. One single circuit.",
            lead: "The merchant's cash feeds the ATM. Withdrawals clear through PROSA. Only the surplus travels.",
            steps: [
                { n: "01", title: "The merchant deposits", body: "Each shift close goes straight into the recycling ATM. Device, date, time and amount are recorded." },
                { n: "02", title: "Customers withdraw", body: "Any cardholder withdraws from that same cash. PROSA settles between banks." },
                { n: "03", title: "Only the surplus moves", body: "At ~80% capacity, the CIT carrier picks up only what's left over. Fewer visits, lower risk." },
            ],
        },
        services: {
            eyebrow: "Five service lines",
            title: "A complete cash and infrastructure platform.",
            lead: "Pentomino integrates hardware, bank connectivity, 24/7 operations and a sponsor-based commercial model.",
            items: [
                { tag: "CASH", title: "Pentomino CASH", body: "Cash recycling and management at the point of sale. Merchant deposits and customer withdrawals from the same device." },
                { tag: "NETWORK", title: "Pentomino NETWORK", body: "Multi-bank network with PROSA and E-Global connectivity. Switching, routing and operation reconciliation." },
                { tag: "TECH", title: "Pentomino TECH", body: "Multi-vendor 24/7 monitoring, real-time alerts, help desk and daily reconciliation." },
                { tag: "PAYMENTS", title: "Pentomino PAYMENTS", body: "Bill payments, airtime, transfers and remittance pickup at the merchant's ATM." },
                { tag: "PARTNERS", title: "Pentomino PARTNERS", body: "Sponsor model with banks and institutions. Anchor merchants with revenue share per operation." },
            ],
        },
        audiences: {
            eyebrow: "Who it's for",
            title: "Three audiences. One shape.",
            lead: "Each actor of the circuit maps to a clear piece inside the Pentomino symbol.",
            items: [
                { piece: "1", tag: "Piece 1 · the inlet", title: "Merchants", bullets: ["Fewer CIT pickups, less manual cash handling", "Revenue share per withdrawal performed in your store", "More foot traffic with payments and services on-site"], cta: "Merchant proposition" },
                { piece: "4", tag: "Piece 4 · settlement", title: "Sponsor banks", bullets: ["Network expansion with zero CAPEX / OPEX", "Low-cost acquisition and brand presence", "Surplus funding through the usual channel"], cta: "Bank proposition" },
                { piece: "3", tag: "Piece 3 · the user", title: "People", bullets: ["Financial services right at your point of purchase", "Zero fees for sponsor-bank cardholders", "Payments, airtime and remittances in one place"], cta: "What we offer to people" },
            ],
        },
        operation: {
            eyebrow: "Live operation",
            title: "Not a pitch deck. A network running today.",
            lead: "In June 2025, for every peso dispensed in withdrawals, 1.95 pesos came in from merchants. Cash stayed working at the point of sale instead of traveling.",
            receipt: {
                title: "Network snapshot · June 2025",
                rows: [
                    ["Active ATMs", "22"],
                    ["Merchant deposits", "$66.7 M"],
                    ["Dispensed in withdrawals", "$34.2 M"],
                    ["Withdrawals", "15,987"],
                    ["Balance inquiries", "1,503"],
                    ["In per peso dispensed", "1.95×"],
                ],
                source: "Source: Pentomino network operations report, June 2025.",
            },
        },
        closing: {
            eyebrow: "Let's talk",
            title: "Let's start with one location.",
            lead: "We'll pick the branch with the highest cash volume, size the savings with your data and launch a measurable pilot.",
            ctaMain: "Chat on WhatsApp",
            ctaAlt: "Send us an email",
        },
        footer: {
            tag: "Cash-recycling ATMs inside Mexican merchants.",
            slogan: "Trust. Delivered.",
            product: "Product",
            productLinks: [["Services", "/servicios"], ["Merchants", "/comercios"], ["Banks", "/bancos"], ["People", "/personas"]],
            company: "Company",
            companyLinks: [["About", "/nosotros"], ["Contact", "/contacto"]],
            contact: "Contact",
            legal: "© 2026 Pentomino Cash Cajeros Automáticos, S.A.P.I. de C.V.",
            privacy: "Privacy notice",
            addressLine1: "Av. Coyoacán 1622 P.B., Col. Del Valle Sur",
            addressLine2: "C.P. 03104, Benito Juárez, CDMX",
        },
        wa: {
            label: "WhatsApp chat",
            message: "Hi, I'd like to learn more about Pentomino",
        },
        pentomino: {
            marks: {
                "1": "Merchant",
                "2": "ATM",
                "3": "Cardholder",
                "4": "PROSA",
                "5": "CIT",
            },
        },
        chat: {
            openLabel: "Ask Pentomino",
            fabTitle: "Assistant",
            fabSub: "AI-powered answers",
            title: "Pentomino Assistant",
            subtitle: "AI-powered · Claude",
            closeLabel: "Close assistant",
            placeholder: "Type your question…",
            send: "Send",
            sending: "Thinking…",
            intro: "Hi. I can explain how cash recycling works, what merchants or banks earn, and how compliance is handled. What would you like to know?",
            suggestions: [
                "How does cash recycling work?",
                "How much could my store save?",
                "What does a sponsor bank earn?",
                "How fast is my deposit credited?",
            ],
            typing: "Typing",
            errorGeneric: "I couldn't reach the assistant.",
            errorFallbackCta: "Message us on WhatsApp and we'll get back to you.",
            disclaimer: "The assistant can be wrong. For case-specific figures, use the calculator or talk to our team. Don't share banking or personal data.",
            waBtn: "WhatsApp",
            clear: "New conversation",
            cleared: "Conversation reset.",
        },
        servicesPage: {
            eyebrow: "What we do",
            title: "Five lines, one platform.",
            lead: "Pentomino integrates hardware, bank connectivity, 24/7 monitoring and a sponsor-based commercial model — designed to put cash to work right where it comes in.",
            sections: [
                {
                    tag: "CASH",
                    title: "Cash recycling and management",
                    body: "The recycling ATM authenticates, counts and secures the merchant's banknotes. When a customer withdraws, that same cash is used. Surplus credited in T+1 to T+2.",
                    bullets: [
                        "Merchant deposit tracked by device, date, time and amount",
                        "Authentication and secure storage of banknotes",
                        "Merchant reimbursement on the next business day (T+1 to T+2)",
                        "Scheduled pickup at ~80% device capacity",
                    ],
                },
                {
                    tag: "NETWORK",
                    title: "Multi-bank network and connectivity",
                    body: "Direct connection to PROSA and E-Global. Switching, routing and reconciliation of every operation between issuing banks and the sponsor.",
                    bullets: [
                        "PROSA and E-Global connectivity",
                        "Transactional switching and routing",
                        "Daily reconciliation with every counterpart",
                        "Interoperable with any cardholder",
                    ],
                },
                {
                    tag: "TECH",
                    title: "24/7 monitoring and infrastructure",
                    body: "Multi-vendor platform that watches each ATM in real time: status, capacity, incidents and operation audit. Help desk and field maintenance.",
                    bullets: [
                        "Real-time 24/7 multi-vendor monitoring",
                        "Alerts for capacity, failure, attempt or exception",
                        "Help desk and maintenance dispatch",
                        "Daily reconciliation and audit log",
                    ],
                },
                {
                    tag: "PAYMENTS",
                    title: "Transactional services",
                    body: "More than an ATM: everyday services that drive customers into the store and keep them inside.",
                    bullets: [
                        "Utility and tax payments (power, water, phone, gas)",
                        "Airtime and TAG top-ups",
                        "Interbank transfers",
                        "Card payments and remittance pickup",
                    ],
                },
                {
                    tag: "PARTNERS",
                    title: "Sponsor model and partnerships",
                    body: "The sponsor bank provides licensing and settlement; Pentomino provides hardware, operation and merchants. Revenue share with anchor merchants.",
                    bullets: [
                        "Bank sponsorship: expansion with zero CAPEX for the bank",
                        "Anchor merchants with per-operation revenue share",
                        "Regional integrators and partners",
                        "Commercial governance with agreed SLAs",
                    ],
                },
            ],
        },
        commercePage: {
            audienceTag: "Merchants · piece 1, the cash inlet",
            eyebrow: "For merchants",
            title: "Fewer pickups. More reasons to enter your store.",
            lead: "Your cash stays at the point of sale and is dispensed to your customers in withdrawals. Pay fewer pickups, your team stops bagging and counting, and you earn a share of every withdrawal.",
            benefits: [
                { title: "Operational savings", body: "Only the surplus travels. Fewer visits, lower risk fees and lower per-thousand processing." },
                { title: "Revenue per withdrawal", body: "Share in the fees of every withdrawal and balance inquiry at your ATM." },
                { title: "Your own screen", body: "Promotions, loyalty and cross-sell at the moment of highest customer attention." },
                { title: "More foot traffic", body: "Payments, airtime and withdrawals: everyday services that bring people in." },
            ],
            timeTable: {
                title: "Up to 72% less cash-handling time",
                lead: "Estimate for a store with 28 shift closes per month. Bagging, logging, filling out slips and handing over to the carrier disappear: the ATM counts and records.",
                header: ["Activity, 28 closes", "Today", "With recycler"],
                rows: [
                    ["Collect cash from registers", "336 min", "168 min"],
                    ["Ticket sign-off", "28 min", "28 min"],
                    ["Cash bagging", "140 min", "—"],
                    ["Logging in control system", "140 min", "—"],
                    ["Filling slips", "140 min", "—"],
                    ["Deposit", "42 min", "42 min"],
                    ["Sign and hand to CIT", "25 min", "—"],
                    ["Total", "851 min · 14.2 h", "238 min · 4 h"],
                ],
                footnote: "Estimated times; validated in the pilot.",
            },
            setup: {
                title: "No equipment investment",
                left: { h: "Pentomino provides", p: "The recycling ATM, installation, technology, 24/7 monitoring, help desk and maintenance." },
                right: { h: "Your store provides", p: "Space, power and connectivity, plus the cash from sales that feeds the ATM." },
            },
            steps: {
                title: "How we start",
                lead: "A pilot in one location, with shared measurement from day one.",
                items: [
                    { n: "01", h: "Select", p: "The branches with the highest cash volume and foot traffic." },
                    { n: "02", h: "Size", p: "Current costs, pickup frequency and transactional opportunity, with your data." },
                    { n: "03", h: "Activate", p: "ATM, services, launch campaign and shared measurement." },
                ],
            },
        },
        banksPage: {
            audienceTag: "Banks & institutions · piece 4, settlement",
            eyebrow: "For sponsor banks",
            title: "More transactional network, without rolling out your own.",
            lead: "Pentomino provides the ATMs, locations and operation. Your institution brings the connection to the payments system and monetizes every operation.",
            benefits: [
                { title: "Recurring revenue", body: "A fee for every withdrawal and inquiry in the network, plus any additional services." },
                { title: "Low-cost funding", body: "Merchants' surplus reaches your accounts through the usual CIT channel." },
                { title: "Expansion with zero CAPEX", body: "Hardware, locations, technology and daily operation are on Pentomino." },
                { title: "Brand presence", body: "Banking services in commercial points where a branch wouldn't be viable." },
            ],
            compliance: {
                title: "More traceability, not a new route for cash",
                lead: "The same channels, counterparts and reporting triggers remain active. Pentomino adds electronic evidence to the cycle.",
                items: [
                    { h: "No direct contact with cash", p: "The bank receives settlements via PROSA or deposits from CIT. Never cash directly from the merchant." },
                    { h: "The CIT carrier remains an obligated entity", p: "Keeps its notifications and controls per its current framework." },
                    { h: "Every deposit is recorded", p: "Identified merchant, device, date, time and amount, with daily reconciliation." },
                    { h: "Tailored limits and alerts", p: "Merchant profiles, device-level limits, alert rules and event log — defined with your Compliance team." },
                ],
            },
            roadmap: {
                title: "From validation to a controlled pilot",
                lead: "A sequence with clear decision gates and responsibilities.",
                items: [
                    { n: "01", h: "Executive table", p: "Scope, owners and success criteria." },
                    { n: "02", h: "Due diligence", p: "Data, controls, architecture and counterparts." },
                    { n: "03", h: "Term sheet", p: "Fees, limits, guarantees, SLAs and governance." },
                    { n: "04", h: "Pilot", p: "Certify, launch and measure a bounded set of devices." },
                ],
            },
        },
        peoplePage: {
            audienceTag: "People · piece 3, the user",
            eyebrow: "For people",
            title: "Financial services where you already shop.",
            lead: "Find a Pentomino ATM at the merchant you already visit: withdraw cash, pay bills, top up airtime or pick up remittances without leaving the store.",
            services: {
                title: "What you can do at a Pentomino ATM",
                items: [
                    { h: "Cash withdrawal", p: "With any debit or credit card accepted by the network." },
                    { h: "Balance inquiry", p: "Quick and secure, right where you're already shopping." },
                    { h: "Bill payments", p: "Electricity, water, phone, gas and local taxes." },
                    { h: "Airtime top-ups", p: "All major carriers, plus TAG recharge." },
                    { h: "Transfers and card payments", p: "Between participating banks, with instant confirmation." },
                    { h: "Remittance pickup", p: "Receive international transfers in pesos, hassle-free." },
                ],
            },
            perks: {
                title: "Designed for you",
                items: [
                    { h: "Zero fees", p: "If you are a sponsor-bank cardholder, you pay no withdrawal fee." },
                    { h: "At your point of purchase", p: "Skip the trip to the bank: ATMs sit where you already run errands." },
                    { h: "Store hours", p: "Available while the store is open, with no bank-branch queues." },
                    { h: "Store security", p: "Store surveillance, cameras and staff present while you transact." },
                ],
            },
        },
        aboutPage: {
            eyebrow: "Who we are",
            title: "We turn scattered cash into financial infrastructure.",
            lead: "Pentomino Cash is a Mexican company that connects merchants, technology and the payments system. We operate a network of cash-recycling ATMs inside high-traffic merchants.",
            mission: {
                title: "We don't just operate ATMs",
                items: [
                    { h: "Physical network", p: "Devices, locations and field operation." },
                    { h: "Platform", p: "Multi-vendor monitoring and remote device management." },
                    { h: "Infrastructure", p: "Switching, routing and operation reconciliation." },
                    { h: "Sponsor model", p: "We scale transactions through a sponsor institution, without rolling out our own bank network." },
                ],
            },
            values: {
                title: "Trust. Delivered.",
                lead: "Trust in cash handling isn't promised — it's demonstrated by operating. That's why we work by three rules.",
                items: [
                    { n: "01", h: "Figures with date and source", p: "We publish real operating data and we say when it's from." },
                    { n: "02", h: "Each tramway with its owner", p: "We integrate regulated players without replacing their obligations." },
                    { n: "03", h: "Everything is measured", p: "Every pilot starts with agreed success criteria and shared measurement." },
                ],
            },
            team: {
                title: "Team",
                lead: "A multidisciplinary team with experience in financial operations, technology and institutional relations.",
                people: [
                    { name: "Lumen Yvonne Espinosa Félix", role: "General Director" },
                ],
                footnote: "The full team will be published together with the results of the first pilot.",
            },
            legal: {
                title: "Legal data",
                items: [
                    ["Legal name", "Pentomino Cash Cajeros Automáticos, S.A.P.I. de C.V."],
                    ["Tax address", "Av. Coyoacán 1622 P.B., Col. Del Valle Sur, C.P. 03104, Benito Juárez, CDMX"],
                    ["Phone", "55 8580 2818"],
                    ["Email", "lumen@pentocash.mx"],
                ],
            },
        },
        calc: {
            inputs: { title: "Enter your data" },
            tags: { porConfirmar: "To confirm", supuesto: "Assumption" },
            groups: {
                tarifasETV: "Your CIT carrier fees",
                costosInternos: "Your internal costs",
                operacionYComisiones: "Operation and fees",
                fondeo: "Surplus funding",
            },
            labels: {
                sucursales: "Branches or points of sale",
                efectivoMensualPorSucursal: "Monthly cash received per branch",
                recoleccionesSemana: "Pickups per week, per branch",
                retirosPorCajero: "Expected withdrawals per ATM per month",
                tarifaServicio: "Fee per service",
                cuotaRiesgoMillar: "Risk fee per thousand",
                procesoMillar: "Processing fee per thousand",
                minutosExcedentes: "Excess minutes per service",
                horasPorServicio: "Staff hours per pickup",
                costoHora: "Staff cost per hour",
                diasTransito: "Days until deposit credits",
                tasaOportunidad: "Annual opportunity cost (%)",
                cajeros: "Pentomino ATMs in your network",
                efectivoDepositadoPorCajero: "Monthly cash deposited per ATM",
                comisionSponsorRetiro: "Sponsor fee per withdrawal (no VAT)",
                comisionSponsorConsulta: "Sponsor fee per inquiry (no VAT)",
                pctConsultas: "Inquiries per 100 withdrawals (%)",
                retiroPromedio: "Average withdrawal",
                diasPermanenciaFondeo: "Average funding stay (days)",
                margenFondeoAnual: "Annual financial margin (%)",
            },
            helps: {
                recoleccionesSemanaHelp: "How often the CIT carrier currently stops by.",
                retirosPorCajeroHelp: "The Pentomino network averaged 727 per ATM in June 2025. High-traffic stores exceed 2,000.",
            },
            commerce: {
                hero: {
                    eyebrow: "Savings calculator",
                    title: "How much would you save with Pentomino?",
                    lead: "Enter your real operation: branches, monthly cash and current CIT pickup frequency. Compare your current cost against a recycling ATM in real time.",
                },
                savingLabel: "Estimated monthly savings",
                extraCost: "Additional monthly cost",
                perYear: "per year",
                ofCurrent: "of your current cost",
                perMonth: "Per month",
                today: "Today",
                withPentomino: "With Pentomino",
                pickups: "Pickups",
                cashShipped: "Cash shipped",
                carrierPay: "CIT carrier payment",
                internalCosts: "Internal costs",
                pentoFee: "Pentomino service fee",
                yourShare: "Your share from withdrawals",
                netService: "Pentomino service, net of share",
                totalCost: "Total cost",
                recycled: "of cash dispensed in withdrawals, no longer travels",
                hoursFreed: "staff hours freed per month",
                warn: "With these inputs, traditional CIT comes out cheaper by {amount} per month. This usually happens when the ATM gets few withdrawals: try more withdrawals or fewer current pickups.",
                legend: { carrier: "CIT carrier", internal: "Internal costs", netService: "Pentomino service" },
                footnote: "Estimate using 2026 reference fees and real network operation. The definitive case is built with your data and your current CIT contract. Figures without VAT.",
                ctaWithResult: "Send my {amount} result on WhatsApp",
            },
            sponsor: {
                hero: {
                    eyebrow: "Sponsor calculator",
                    title: "How much does a Pentomino network generate for your bank?",
                    lead: "Adjust network size, per-operation fee and funding margin. Estimates monthly revenue using the network's current transaction costs.",
                },
                incomeLabel: "Estimated monthly revenue",
                perYear: "per year",
                perAtmPerMonth: "per ATM per month",
                feeWithdrawals: "Withdrawal fees",
                feeInquiries: "Balance inquiry fees",
                participation: "Revenue share",
                fundingMargin: "Surplus funding margin",
                totalMonthly: "Monthly total",
                composition: "Revenue composition",
                legend: { fees: "Fees", share: "Revenue share", funding: "Funding margin" },
                monthlyOps: "monthly operations",
                surplusDeposit: "in surplus deposited",
                prosaCleared: "cleared via PROSA",
                zeroInvestment: "equipment investment for the sponsor",
                footnote: "Estimate. Per-operation fees come from the network's current transaction cost; funding margin is an editable assumption. Final terms are agreed in the working session.",
                ctaWithResult: "Send my {amount} result on WhatsApp",
            },
        },
        contact: {
            eyebrow: "Book a session",
            title: "Tell us about your operation.",
            lead: "Merchant, bank or partner: leave us your details and one of our executives will reach out within 24 business hours. You can also WhatsApp us for an immediate reply.",
            waBanner: {
                title: "WhatsApp — primary channel",
                sub: "Instant reply during business hours",
                cta: "Open WhatsApp",
            },
            info: {
                title: "Contact details",
                phoneLabel: "Phone",
                emailLabel: "Email",
                addressLabel: "Offices",
                hoursLabel: "Hours",
                hours: "Mon–Fri · 9:00 am – 6:00 pm (CDMX)",
            },
            map: {
                title: "How to get there",
                lead: "Av. Coyoacán 1622 P.B., Col. Del Valle Sur, CDMX.",
            },
            form: {
                title: "Contact form",
                lead: "Leave us your details and we'll be in touch.",
                name: "Full name",
                email: "Email",
                phone: "Phone",
                company: "Company or institution",
                type: "You are a…",
                typeOptions: [["comercio", "Merchant"], ["banco", "Bank or institution"], ["persona", "Interested person"], ["socio", "Commercial partner"]],
                message: "Message",
                messagePlaceholder: "Briefly, what are you looking for?",
                submit: "Send message",
                submitting: "Sending…",
                ok: "Thank you! We received your message. We'll be in touch within 24 business hours.",
                err: "We couldn't send your message. Try again or WhatsApp us.",
            },
        },
    },
};

export const WHATSAPP_URL_ES =
    "https://wa.me/525585802818?text=" +
    encodeURIComponent("Hola, me interesa conocer más sobre Pentomino");

export const WHATSAPP_URL_EN =
    "https://wa.me/525585802818?text=" +
    encodeURIComponent("Hi, I'd like to learn more about Pentomino");

export const CONTACT = {
    phone: "55 8580 2818",
    phoneHref: "tel:+525585802818",
    email: "lumen@pentocash.mx",
    emailHref: "mailto:lumen@pentocash.mx",
};
